import React from "react";
import { useHistory } from "react-router-dom";
import useUserAgent from "../../../hooks/useUserAgent.js";
import useCreateUrl from "../../../hooks/useCreateUrl.js";
import { useCheckInData } from "../../../hooks/useCheckInData.js";
import { WebCheckinInnerDesktop } from "./WebCheckinInner.desktop.js";
import { WebCheckinInner as WebCheckinInnerMobile } from "./WebCheckinInner.js";
import { useSelector } from "react-redux";
import { getOrder } from "../../../store/order/selectors.js";
import { assert } from "../../../utils/assert.js";
import { groupLegsByAirlineReference } from "../../../utils/groupLegsByAirlineReference.js";
export const WebCheckinInner = () => {
    const { isMobile } = useUserAgent();
    const history = useHistory();
    const { createUrl } = useCreateUrl();
    const order = useSelector(getOrder);
    assert(order);
    const { filteredLegs, segment, segmentIndex } = useCheckInData(order);
    if (filteredLegs.length === 0 || !segment || segmentIndex === undefined) {
        history.push(createUrl(`/booking/order-details/${order.orderToken}`));
        return null;
    }
    const airlineReferenceGroups = groupLegsByAirlineReference(order, segmentIndex, segment.legs);
    const filteredLegsWithOpenedCheckIn = [];
    airlineReferenceGroups.forEach((group) => {
        const checkinInfoForLeg = order.carrierCheckinInfo?.find((checkinInfo) => checkinInfo.legIdentifier.segmentIndex === segmentIndex &&
            checkinInfo.legIdentifier.legIndex === group.startLegIndex);
        if (checkinInfoForLeg) {
            filteredLegsWithOpenedCheckIn.push({
                leg: group.journeyLeg,
                checkinInfoForLeg
            });
        }
    });
    return isMobile ? (React.createElement(WebCheckinInnerMobile, { order: order, segmentIndex: segmentIndex, segment: segment, filteredLegsWithOpenedCheckIn: filteredLegsWithOpenedCheckIn })) : (React.createElement(WebCheckinInnerDesktop, { order: order, segmentIndex: segmentIndex, segment: segment, filteredLegsWithOpenedCheckIn: filteredLegsWithOpenedCheckIn }));
};
